import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzoneBG = ({ onBGDropHandler, bgPath }) => (
  <ImageDropzone
    inputName="bgImage"
    label="BG Image"
    imagePath={bgPath}
    alt="Background"
    onImageReady={onBGDropHandler}
    prepareOptions={{ maxSize: 1600 }}
  />
);

export default DropzoneBG;
